// extracted by mini-css-extract-plugin
export default {"Changes_form":"partiii_Changes_form__zt25w","Epigenome_Swiper":"partiii_Epigenome_Swiper__8FQaf","Epigenome_Header":"partiii_Epigenome_Header__DTo5p"};